/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
import MultiSelect from '../../../../components/MultiSelect'
import { useSelector } from 'react-redux';

export default function AssociationSection(
    {state,
        setstate,handleAddSection,handleRemove,submitSelected,
        setsubmitSelected}) {
    const {association}=state
    const Association=useSelector(state=>state.Association);
    const {year,class_name}=Association.selectedDropdown
    const {common}=useSelector(state=>state.CommonData);
    const{classes,
        sections,subjects,exams,teachers,
        academic_year}=common;

    function modifySubjectNames(subjects) {
        return subjects.map(subject => {
            if (subject.is_optional) {
                return {
                    ...subject,
                    name: `${subject.name} (Optional)`
                };
            } else {
                return subject;
            }
        });
    }
        
    const modifiedSubjects = modifySubjectNames(subjects);

    return (
        <div className="mt-8 border border-[#E6E8EA]">
            <div className="flex items-center w-full pb-[7px] p-2 formHeaderbg">
                <p className="text-f7 font-semibold text-[#031624] min-w-[170px] max-w-[170px]">Section</p>
                <div className="w-full ml-1">
                    <div className="flex items-center -mx-5">
                        <div className="w-1/3 px-5">
                            <p className="text-f7 font-semibold text-[#031624] w-full">Subjects</p>
                        </div>
                        <div className="w-1/3 px-5">
                            <p className="text-f7 font-semibold text-[#031624]">Exams</p>
                        </div>
                        <div className="w-1/3 px-5">
                            <p className="text-f7 font-semibold text-[#031624]">Teachers</p>
                        </div>
                    </div>
                </div>
            </div>
            {association.map((associate,i)=>(
                <div className="flex items-center w-full py-4 border-t border-[#E6E8EA] p-2" key={associate.section_id}>
                    <p className="text-f7 font-semibold text-[#031624] min-w-[170px] max-w-[170px] break-all">{associate.section_name}</p>
                    <div className="w-full ml-1">
                        <div className="flex items-center -mx-5">
                            <div className="w-1/3 px-5">
                                <MultiSelect 
                                    classKey={`w-full border border-[#D0D5DD] rounded py-1.5 px-1.5 pr-[32px] outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out max-h-[133px] overflow-y-auto`}
                                    dropdown={modifiedSubjects}
                                    handleSelect={handleAddSection}
                                    selected={state.association[i].subjects ||[]}
                                    id="subject_id"
                                    name="subject_name"
                                    type="Subjects"
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}
                                    index={i}
                                    handleRemove={handleRemove}

                                />
                            </div>
                            <div className="w-1/3 px-5">
                                <MultiSelect 
                                    classKey={`w-full border border-[#D0D5DD] rounded py-1.5 px-1.5 pr-[32px] outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out max-h-[133px] overflow-y-auto`}
                                    dropdown={exams}
                                    handleSelect={handleAddSection}
                                    selected={state.association[i].exams ||[]}
                                    id="exam_id"
                                    name="exam_name"
                                    type="Exams"
                                    index={i}
                                    handleRemove={handleRemove}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}

                                />
                            </div>
                            <div className="w-1/3 px-5">
                                <MultiSelect 
                                    classKey={`w-full border border-[#D0D5DD] rounded py-1.5 px-1.5 pr-[32px] outline-0 text-f7 text-[#031624] text-left font-normal transition duration-150 ease-in-out max-h-[133px] overflow-y-auto`}
                                    dropdown={teachers}
                                    handleSelect={handleAddSection}
                                    selected={state.association[i].teachers ||[]}
                                    id="teacher_id"
                                    name="teacher_name"
                                    type="Teachers"
                                    index={i}
                                    handleRemove={handleRemove}
                                    submitSelected={submitSelected}
                                    setsubmitSelected={setsubmitSelected}

                                />
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div> 
        
    )
}
